export default __webpack_public_path__ + "static/media/trustStatement.6443b772.png";